import { useParamsSearch } from '@anytag/shared-hooks';
import { UsersSearchSchemaType } from '../schemaTypes';

export const useUsersFilter = () => useParamsSearch<UsersSearchSchemaType>();
